





















import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  inheritAttrs: false,
})
export default class BaseCard extends Vue {
  @Prop({ default: "card" })
  id!: string;

  @Prop({ type: Boolean })
  noBody!: boolean;

  get listeners() {
    return {
      ...this.$listeners,
    };
  }
}
